/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetsMelcoModelsThreadChartProduct
 */
export interface AssetsMelcoModelsThreadChartProduct {
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsThreadChartProduct
     */
    product_code?: string | null;
}

export function AssetsMelcoModelsThreadChartProductFromJSON(json: any): AssetsMelcoModelsThreadChartProduct {
    return AssetsMelcoModelsThreadChartProductFromJSONTyped(json, false);
}

export function AssetsMelcoModelsThreadChartProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetsMelcoModelsThreadChartProduct {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
    };
}

export function AssetsMelcoModelsThreadChartProductToJSON(value?: AssetsMelcoModelsThreadChartProduct | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'product_code': value.product_code,
    };
}


